<app-dialog
  [title]="data.title"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    {
      text: 'Create',
      isDisabled: !publishForm.valid || IsCreate,
      spin: spin
    }
  ]"
  (action)="dialogAction($event)"
  (close)="dialogRef.close()"
>
  <div class="input-container my-4">
    <label class="input-container_label">Enter your ASIN</label>
    <div class="input-container_wrapper">
      <input
        type="text"
        class="input-container_input"
        (input)="search($event)"
      />
      <app-button [isDisabled]="!asin" [spin]="loader" (click)="submit()">
        Search</app-button
      >
    </div>
  </div>
  <div class="sku_detail" *ngIf="publisListing">
    <div class="sku_image">
      <img [src]="publisListing?.image" />
    </div>
    <div class="w-100">
      <div class="sku">
        <div class="sku_title">{{ publisListing?.itemName }}</div>
        <div class="sku_chips">
          <app-sku-chip
            *ngIf="publisListing?.asin"
            [name]="'ASIN'"
            [value]="publisListing?.asin"
            [link]="asinLink"
          ></app-sku-chip>
          <app-sku-chip
            *ngIf="publisListing?.fnsku"
            [name]="'FnSku'"
            [value]="publisListing?.fnsku"
          ></app-sku-chip>
        </div>
      </div>
      <div class="panel-detail" *ngIf="publisListing">
        <div>
          <span class="label">Category</span>
          <p>{{ publisListing?.category }}</p>
        </div>
        <div>
          <span class="label">Rank</span>
          <p>{{ publisListing?.rank }}</p>
        </div>
        <div>
          <span class="label">Dimension</span>
          <p>{{ publisListing?.size }}</p>
        </div>
        <div *ngIf="publisListing?.supplier_declared_dg_hz_regulation">
          <span class="label"> Hazmatous Product </span>
          <p>{{ publisListing.supplier_declared_dg_hz_regulation }}</p>
        </div>
        <div *ngIf="publisListing?.buyBoxListingPrice">
          <span class="label"> Buy Box </span>
          <p>{{ publisListing.buyBoxListingPrice | currency}}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container publishForm">
    <div class="row justify-content-center">
      <div [formGroup]="publishForm" class="col-md-10">
        <div class="input-container">
          <label class="input-container_label">Seller SKU</label>
          <div class="input-container_wrapper w-100">
            <input
            class="input-container_input"
            type="text"
            formControlName="sellerSku"
            />
            <app-button (click)="openDialog()">generate</app-button>
          </div>
        </div>
        <div class="input-container">
          <label class="input-container_label">Your Price</label>
          <div class="input-container_wrapper w-100">
            <input
              type="number"
              class="input-container_input input-container_input--number input-container_price"
              min="0"
              formControlName="price"
            />
            <span class="input-container_icon">
              <i class="fa fa-dollar-sign"></i>
            </span>
          </div>
        </div>
        <div class="input-container">
          <label class="input-container_label">Item Condition</label>
          <mat-select
            class="input-container_input input-container_input--select"
            formControlName="itemCondition"
          >
            <mat-option
              *ngFor="let item of itemConditionArray"
              [value]="item.value"
            >
              {{ item.name }}
            </mat-option>
          </mat-select>
        </div>
        <div class="input-container">
          <label class="input-container_label">Dangerous Goods Regulations</label>
          <mat-select
            class="input-container_input input-container_input--select"
            formControlName="hazamatousProduct"
          >
            <mat-option
              *ngFor="let item of hazamtousProduct"
              [value]="item.value"
            >
              {{ item.name }}
            </mat-option>
          </mat-select>
        </div>
       <ng-container *ngIf="isShowProduct">
        <div class="input-container" >
          <label class="input-container_label">{{publishForm.get('hazamatousProduct')?.value == 'ghs' ? 'Ghs Class' : 'Hazmat Aspect'}}</label>
          <mat-select
            class="input-container_input input-container_input--select"
            formControlName="hazmat"
          >
            <mat-option
              *ngFor="let item of selectedhazamatousProduct"
              [value]="item.value"
            >
              {{ item.name }}
            </mat-option>
          </mat-select>
        </div>
        <div class="input-container">
          <label class="input-container_label">{{publishForm.get('hazamatousProduct')?.value == 'ghs' ? 'safety Data Sheet Url' : 'Hazmat'}}</label>
          <input
            type="text"
            class="input-container_input"
            formControlName="hazmatUrl"
          />
        </div>
       </ng-container>
        <div class="input-container">
          <label class="input-container_label">Quantity</label>
          <input
            type="number"
            min="0"
            class="input-container_input"
            formControlName="qty"
          />
        </div>
      <ng-container *ngIf="!isSelectedFba">
        <div class="input-container">
          <label class="input-container_label">Handling Time</label>
          <input
            type="number"
            class="input-container_input"
            formControlName="handlingTime"
          />
        </div>
        <div class="input-container">
          <label class="input-container_label">Merchant Shipping Group</label>
          <mat-select
            class="input-container_input input-container_input--select"
            formControlName="merchantShippingGroup"
          >
            <mat-option
              *ngFor="let item of merchantShippingArray"
              [value]="item"
            >
              {{ item }}
            </mat-option>
          </mat-select>
        </div>
      </ng-container>
        <div class="input-container align-items-start mt-4">
          <label class="input-container_label">Fulfillment Channel</label>
          <mat-radio-group formControlName="fullfillmentChannel">
            <mat-radio-button [value]=true class="mat-radio-lg"
              > Fulfilled by Amazon 
              <small>( Amazon will ship and provide customer services )</small
              ></mat-radio-button
            >
            <mat-radio-button [value]=false class="mat-radio-lg"
            >Merchant Fulfilled 
            <small>( I will ship this item my self )</small></mat-radio-button
          >
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
</app-dialog>
